import { render, staticRenderFns } from "./PublicAdmissionForm.vue?vue&type=template&id=39ce3460&scoped=true"
import script from "./PublicAdmissionForm.vue?vue&type=script&lang=js"
export * from "./PublicAdmissionForm.vue?vue&type=script&lang=js"
import style0 from "./PublicAdmissionForm.vue?vue&type=style&index=0&id=39ce3460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ce3460",
  null
  
)

export default component.exports